<template>
  <div>
    <h2 class="mb-5">Review Invitations</h2>

    <v-row v-if="invitations.length > 0">
      <v-col
        cols="12"
        lg="6"
        v-for="invitation in invitations"
        :key="invitation.id"
      >
        <InvitationCard :invitation="invitation" />
      </v-col>
    </v-row>

    <v-card v-else max-width="700">
      <v-card-text class="py-5">
        <h2>No new review invitations at this time</h2>
        <p class="mt-3">
          If you have accepted review invitations click the button below to view
          your pending reviews
        </p>
        <v-btn color="orange accent-3" to="/reviews/pending" class="mt-2">
          Pending reviews
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import InvitationCard from "./Includes/ReviewInvitationCard";

export default {
  components: {
    InvitationCard,
  },

  data: () => ({
    loading: false,
    invitations: [],
  }),
  methods: {
    fetchInvitations() {
      this.loading = true;
      this.$axios
        .get("/invitations")
        .then(({ data: response }) => {
          this.invitations = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve invitations",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchInvitations();
    this.$bus.$on("invitations.reload", this.fetchInvitations);
  },
};
</script>